import "@ant-design/v5-patch-for-react-19";
import { msalConfig } from "@/config";
import {
  AuthenticationResult,
  EventType,
  PublicClientApplication,
} from "@azure/msal-browser";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import "./tailwind.built.css";
import "./App.css";
import { unregister } from "./registerServiceWorker";

export const msalInstance = new PublicClientApplication(msalConfig);

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="*" element={<App pca={msalInstance} />} />
  )
);

const bootstrap = async () => {
  await msalInstance.initialize();

  // Account selection logic is app dependent. Adjust as needed for different use cases.
  // Set active acccount on page load
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
  }

  // Optional - This will update account state if a user signs in from another tab or window
  msalInstance.enableAccountStorageEvents();

  msalInstance.addEventCallback((event) => {
    // set active account after redirect
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult;
      const account = payload.account;
      msalInstance.setActiveAccount(account);
    }
  });

  root.render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>
  );

  unregister();
};

bootstrap();
